export const locationItemData = {
  name: {
    display: true,
    search: {
      name: 'name',
      label: 'Location Name',
    },
    filter: {
      type: 'string',
      name: 'name',
      label: 'Location Name',
      props: {
        placeholder: 'Filter by name',
      },
    },
    type: 'string',
  },
  customer: {
    type: 'object',
    properties: {
      name: {
        display: true,
        search: {
          name: 'customer_name',
          label: 'Customer Name',
        },
        filter: {
          type: 'string',
          name: 'customer_name',
          label: 'Customer Name',
          props: {
            placeholder: 'Filter by customer',
          },
        },
        type: 'string',
      },
      id: {
        type: 'string',
      },
    },
  },
  quote_number: {
    display: true,
    search: {
      name: 'quote_number',
      label: 'Quote Number',
    },
    filter: {
      type: 'string',
      name: 'quote_number',
      label: 'Quote Number',
      props: {
        placeholder: 'Filter by quote number',
      },
    },
    type: 'string',
  },
  policy_number: {
    display: true,
    search: {
      name: 'policy_number',
      label: 'Policy Number',
    },
    filter: {
      type: 'string',
      name: 'policy_number',
      label: 'Policy Number',
      props: {
        placeholder: 'Filter by policy number',
      },
    },
    type: 'string',
  },
  id: {
    type: 'string',
  },
};
